module.exports = __webpack_public_path__ + "static/img/rank_59.4e02f1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_59.png
// module id = UWyw
// module chunks = 0